
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instore-enrollment/[cName]",
      function () {
        return require("private-next-pages/instore-enrollment/[cName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instore-enrollment/[cName]"])
      });
    }
  